import React from 'react'
import PropTypes from 'prop-types'
import styles from './Icon.module.css'

export const availableIconsName = [
  'address',
  'telephone',
  'email',
  'youtube',
  'facebook',
]

// style={{ height: size, width: size, paddingRight: '3px' }}

const address = () => (
  <svg viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M488 312.7V456c0 13.3-10.7 24-24 24H348c-6.6 0-12-5.4-12-12V356c0-6.6-5.4-12-12-12h-72c-6.6 0-12 5.4-12 12v112c0 6.6-5.4 12-12 12H112c-13.3 0-24-10.7-24-24V312.7c0-3.6 1.6-7 4.4-9.3l188-154.8c4.4-3.6 10.8-3.6 15.3 0l188 154.8c2.7 2.3 4.3 5.7 4.3 9.3zm83.6-60.9L488 182.9V44.4c0-6.6-5.4-12-12-12h-56c-6.6 0-12 5.4-12 12V117l-89.5-73.7c-17.7-14.6-43.3-14.6-61 0L4.4 251.8c-5.1 4.2-5.8 11.8-1.6 16.9l25.5 31c4.2 5.1 11.8 5.8 16.9 1.6l235.2-193.7c4.4-3.6 10.8-3.6 15.3 0l235.2 193.7c5.1 4.2 12.7 3.5 16.9-1.6l25.5-31c4.2-5.2 3.4-12.7-1.7-16.9z"
    ></path>
  </svg>
)

const telephone = () => (
  <svg viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"
    ></path>
  </svg>
)

const email = () => (
  <svg viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
    ></path>
  </svg>
)

const youtube = () => (
  <svg viewBox="0 0 13.2 16">
    <path
      fill="currentColor"
      d="M0 11.4V9.8c0-.5.1-1.1.2-1.6.1-.3.3-.6.5-.9.3-.1.6-.3 1-.3.8-.1 1.6-.1 2.5-.2s1.7 0 2.5 0h2.5c.8 0 1.6.1 2.5.2.4 0 .7.2.9.4.3.2.4.5.5.9.1.5.2 1 .2 1.6v3.2c0 .5-.1 1.1-.2 1.6-.1.4-.3.6-.5.9s-.6.4-.9.4c-.9-.1-1.8 0-2.6 0h-5c-.9 0-1.7-.1-2.5-.2-.4 0-.7-.2-.9-.4s-.4-.5-.5-.9c-.1-.5-.1-1-.2-1.5v-1.6zm1-2.3h1v5.1h.8V9.1h1v-.8H1v.8zM2.1 0c.1.2.2.5.3.8l.3.9c.2.4.3.8.3 1.1s.1.6.2.8v2.5H4V3.6L5.2 0h-.9l-.6 2.4L3.1 0h-1zm1.8 13.3v.7c0 .1.1.2.2.2.1.1.2.1.3.1.1 0 .3 0 .4-.1.2-.1.4-.2.5-.4v.5h.8V9.8h-.8v3.5c-.1.1-.2.2-.2.3s-.2.1-.2.1h-.1s0-.1-.1-.1v-.1-3.7h-.8v3.5zm1.4-8.8V3v-.6c0-.2.1-.3.2-.4.1-.1.2-.3.4-.3s.3-.1.5-.1.4 0 .5.1.3.2.4.3c.2 0 .2.2.2.4V5.2c0 .2-.1.3-.2.4-.1.1-.2.3-.3.3s-.4.1-.6.1c-.2 0-.3 0-.5-.1s-.2-.2-.4-.3c0-.1-.1-.3-.1-.4 0-.2-.1-.4-.1-.7zm.7.2c0 .2 0 .4.1.5.1.1.2.2.3.2.1 0 .2-.1.3-.2.1-.1.1-.3.1-.5V2.8c0-.2 0-.4-.1-.5-.1 0-.2-.1-.3-.1-.1 0-.2.1-.3.1-.1.2-.1.3-.1.5v1.9zm.9 9.5h.6v-.4c.2.2.4.3.5.4.1.1.3.1.4.1.2 0 .3 0 .4-.1.2-.1.3-.2.3-.4 0-.1.1-.2.1-.4v-2.3-.5-.4l-.3-.3c-.2-.1-.3-.1-.4-.1-.1 0-.3 0-.4.1s-.3.2-.5.4v-2h-.7v5.9zm.7-.8v-2.7c.1-.1.2-.1.2-.1H8c.1 0 .2.1.3.1.1.1.1.3.1.5V13c0 .2 0 .3-.1.4-.1.1-.2.1-.3.1h-.2c-.1 0-.1 0-.2-.1zM8.2 5v.4c0 .1.1.2.1.3 0 .1.1.2.2.2.2.1.3.1.4.1.1 0 .3 0 .5-.1s.3-.2.5-.4v.6h.8V1.6h-.9v3.3c-.1.2-.1.3-.2.3s-.2.1-.3.1h-.1v-.1-.1-3.5h-1V5zm1.6 7.8c0 .2 0 .4.1.6s.1.3.2.4c.1.1.3.3.4.3s.4.1.6.1c.2 0 .4 0 .6-.1s.3-.2.4-.4c.1-.1.1-.1.1-.2s0-.2.1-.2v-.2-.3h-.8v.5c0 .1-.1.2-.1.2s-.1.1-.2.1-.2-.1-.3-.2c-.1-.1-.1-.3-.1-.5v-.8h1.6v-.9-.6c0-.2-.1-.3-.2-.4-.1-.2-.2-.3-.4-.3-.2-.1-.3-.1-.5-.1s-.4 0-.5.1c-.2.1-.3.2-.4.3-.1.1-.2.3-.2.4s-.1.4-.1.6v1.6zm.8-1.3h.8v-.4c0-.2 0-.3-.1-.5-.1-.1-.2-.2-.3-.2-.1 0-.2.1-.3.2-.1.1-.1.3-.1.5v.4z"
    ></path>
  </svg>
)

const facebook = () => (
  <svg viewBox="0 0 7.8 16">
    <path
      fill="currentColor"
      d="M0 8.5V5.8h2v-.7-1.6c0-.5.1-.9.3-1.3s.3-.8.7-1.1c.3-.3.7-.6 1.2-.8.4-.2 1-.3 1.7-.3.6 0 1 0 1.4.1l.5.1-.1 2.5H6c-.5 0-.8.1-1 .3-.1.2-.2.5-.2.9v1.9h3l-.1 2.7H4.8V16H2V8.5H0z"
    ></path>
  </svg>
)

const availableIcons = {
  address,
  telephone,
  email,
  youtube,
  facebook,
}

const getSvgPath = (name, size) => {
  if (!Object.keys(availableIcons).includes(name)) {
    throw Error(`The icon ${name} does not exist`)
  }

  return availableIcons[name](size)
}

const Icon = ({ name, size = '1em' }) => getSvgPath(name, size)

Icon.propTypes = {
  name: PropTypes.oneOf(availableIconsName).isRequired,
  size: PropTypes.string,
}

export default Icon
